// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__oC77f","location":"Header_location__J3bb7"};